import React from "react";

const TermsOfUse = () => {
  const today = new Date().toLocaleDateString();

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1>Terms of Use</h1>
        <p><strong>Effective Date:</strong> {today}</p>

        <p>
          Welcome to <strong>ChrisOnSite.com</strong> (the “Site”), operated by
          Chris OnSite Auto Detailing (“we,” “our,” or “us”). By accessing or
          using this Site, you agree to these Terms of Use. If you do not agree,
          please do not use the Site.
        </p>

        <h2>1. Use of the Site</h2>
        <p>
          You may use the Site for lawful purposes only, including learning
          about our services and contacting us. You agree not to misuse the
          Site, attempt to gain unauthorized access, or interfere with the
          Site’s operation.
        </p>

        <h2>2. Service Information</h2>
        <p>
          The Site may provide information about detailing services, pricing,
          and availability. All such information is provided for general
          informational purposes and may change at any time without notice.
          Final pricing and availability may depend on vehicle condition,
          location, and scope of work.
        </p>

        <h2>3. Scheduling and Communication</h2>
        <p>
          If you contact us through the Site, by phone, or by text message,
          you authorize us to respond using the contact information you
          provide. Calls or messages may be routed through third-party
          communication providers (such as Twilio). Standard carrier rates
          may apply.
        </p>
        <p>
          For scheduling changes, confirmations, or service updates, we may
          contact you via phone or text. You can request to stop receiving
          messages by contacting us.
        </p>

        <h2>4. No Professional Advice</h2>
        <p>
          Content on the Site is provided for general information only and
          does not constitute professional, legal, or other advice. Any
          reliance on Site content is at your own risk.
        </p>

        <h2>5. Intellectual Property</h2>
        <p>
          The Site and its content (including text, logos, graphics, and
          images) are owned by or licensed to us and are protected by
          intellectual property laws. You may not copy, reproduce,
          distribute, or create derivative works from the Site content
          without our written permission.
        </p>

        <h2>6. Third-Party Links</h2>
        <p>
          The Site may contain links to third-party websites. We are not
          responsible for the content, policies, or practices of
          third-party sites. Accessing third-party links is at your own risk.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          The Site is provided on an “as is” and “as available” basis. We
          make no warranties, express or implied, regarding the Site,
          including warranties of merchantability, fitness for a particular
          purpose, accuracy, or non-infringement.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, we will not be liable for
          any indirect, incidental, special, consequential, or punitive
          damages arising out of or related to your use of (or inability to
          use) the Site.
        </p>

        <h2>9. Privacy</h2>
        <p>
          Your use of the Site is also subject to our Privacy Policy. Please
          review the Privacy Policy page for details on how we collect and
          use information.
        </p>

        <h2>10. Changes to These Terms</h2>
        <p>
          We may update these Terms of Use from time to time. Updates will
          be posted on this page with a revised effective date. Your
          continued use of the Site after changes means you accept the
          updated Terms.
        </p>

        <h2>11. Contact</h2>
        <p>If you have questions about these Terms of Use, please contact:</p>
        <p>
          <strong>Chris OnSite Auto Detailing</strong><br />
          Phone: +1 (949) 323-4900<br />
          Email: chrishornyak051@gmail.com<br />
          Website: ChrisOnSite.com
        </p>

        <div style={styles.footer}>
          <p>Last updated: {today}</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    background: "#f7f7f7",
    minHeight: "100vh",
    padding: "40px 20px",
    fontFamily: "Arial, sans-serif",
    color: "#222",
  },
  container: {
    maxWidth: "800px",
    margin: "0 auto",
    background: "#fff",
    padding: "30px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    lineHeight: 1.6,
  },
  footer: {
    marginTop: "30px",
    fontSize: "0.9em",
    color: "#555",
  },
};

export default TermsOfUse;